
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#EC2F3B","stroke-width":"1.326","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.606 12.932v5.54a2.415 2.415 0 01-2.415 2.414H3.416A2.416 2.416 0 011 18.472V4.742a2.416 2.416 0 012.416-2.416H5.64M1 16.909h10.606"}}),_c('path',{attrs:{"d":"M18.235 1h-7.292a2.652 2.652 0 00-2.651 2.652v3.977a2.652 2.652 0 002.651 2.651h3.315v3.315l3.314-3.315h.663a2.652 2.652 0 002.651-2.651V3.652A2.652 2.652 0 0018.235 1z"}})])])
          )
        }
      }
    